import { useMemo } from 'react'
import styled from 'styled-components'

import type { TrackingWallet } from '@root/entities/wallet-tracking/model'

type TradeMakerCellOwnerProps = {
  wallet: TrackingWallet.TrackingWallet
}

export const TradeMakerCellTracked: React.FC<TradeMakerCellOwnerProps> = ({
  wallet,
}) => {
  const label = useMemo(() => {
    if (wallet.label.length > 6) {
      return wallet.label.slice(0, 6) + '…'
    }
    return wallet.label
  }, [wallet.label])

  return (
    <Root>
      <Emoji>{wallet.emoji}</Emoji>
      <Label>{label}</Label>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: start;
  gap: 4px;

  color: inherit;
  &:link,
  &:visited {
    color: inherit;
  }
  font-family: ${({ theme }) => theme.fontFamily};
`

const Label = styled.div``
const Emoji = styled.div``
